/**
 * Created by Dahang on 17/09/2015.
 */
'use strict';
moduleConfig.registerModule('eclipseApp.reserveDevice', ['eclipseApp.core']);
